loadResortData();

function loadResortData() {
  let resortRef = db.collection('resort').orderBy('resortName');
  resortRef.get().then(function(snapshot) {
    let resortData = [];
    snapshot.forEach(function(doc) {
      resortData.push(doc.data());
    });

    htmlTemplate(resortData);
  });
}

function htmlTemplate(data) {
  var tableId = document.getElementById('admin-resort-table-body');

  let numberCount = 1;

  if (data !== null) {
    for (let i in data) {
      let newData = data[i];
      var tmpl = document.getElementById('template-for-resort-table').content.cloneNode(true);
      tmpl.querySelector('.tableNumber').innerHTML = numberCount;
      tmpl.querySelector('.resortName').innerHTML = newData.resortName;
      tmpl.querySelector('.resortCountry').innerHTML = newData.resortCountry;
      tmpl.querySelector('.editResort').innerHTML = '<a href="#">Edit Data</a>';
      tmpl.querySelector('.editResort').addEventListener('click', function() {
        editResort(newData.id, newData.resortName, newData.resortCountry);
      });
      tableId.appendChild(tmpl);
      numberCount++;
    }
  }

  loadDataTable();
}

function loadDataTable() {
  $('#resortTable').DataTable();

  $('.loading').fadeOut();
}

$('#saveNewResortChanges').click(function() {
  let resortName = $('#resortAddNameChange').val();
  let resortCountry = $('#resortAddCountryChange').val();

  let addNewResortCount = 0;

  if (!resortName || !resortCountry) {
    alert('Please ensure all fields are filled');
    return;
  }

  let resortTable = resortName
    .toLowerCase()
    .split(' ')
    .join('-');

  let saveNewResortRef = db.collection('resort');
  saveNewResortRef
    .add({
      resortName: resortName,
      resortCountry: resortCountry,
      resortTable: resortTable,
    })
    .then(function(docRef) {
      let saveResortId = db.collection('resort').doc(docRef.id);
      return saveResortId
        .update({
          id: docRef.id,
          resortId: docRef.id,
        })
        .then(function() {
          alert('Data Saved!');
          window.location.reload();
        });
    })
    .catch(function(err) {
      console.log(err);
    });
});

function editResort(id, title, country) {
  $('#resortModalLongTitle').html(title);
  $('#resortNameChange').val(title);
  $('#resortCountryChange').val(country);
  $('#resortButton').click();
  $('#saveResortChanges').click(function() {
    let changeCount = 0;
    let changeResortData = $('#resortNameChange').val();
    let changeCountryData = $('#resortCountryChange').val();
    if (changeResortData !== title) {
      changeCount++;
    }
    if (changeCountryData !== country) {
      changeCount++;
    }
    if (changeCount !== 0) {
      let saveResortRef = db.collection('resort').doc(id);
      return saveResortRef
        .update({
          resortTitle: changeResortData,
          resortCountry: changeCountryData,
        })
        .then(function() {
          alert('Data saved');
          window.location.reload();
        })
        .catch(function(err) {
          console.log(err);
        });
    } else {
      alert('No changes to save!');
    }
  });
  $('#deleteResort').click(function() {
    if (confirm('Are you sure you want to delete this resort?') == true) {
      if (confirm('Are you really sure you want to delete this resort?') == true) {
        let resortRef = db.collection('resort').doc(id);
        resortRef
          .delete()
          .then(function() {
            alert('Data deleted');
            window.location.reload();
          })
          .catch(function(err) {
            console.log(err);
          });
      }
    } else {
      alert('Data deletion cancelled');
    }
  });
}
